import { render, staticRenderFns } from "./HeaderContent.vue?vue&type=template&id=ec5f1ffa&"
import script from "./HeaderContent.vue?vue&type=script&lang=js&"
export * from "./HeaderContent.vue?vue&type=script&lang=js&"
import style0 from "./HeaderContent.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports